module.exports = __webpack_public_path__ + "img/nu_logo.d19a1a81.png";